import { memo, useCallback, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import _map from 'lodash/map';
// Local files
import { StyledList } from './List.styled';
import Item from './Item/Item';
import ListSkeleton from 'components/Common/Feedback/ListSkeleton/ListSkeleton';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useSessions from 'hooks/useSessions';
import { sessionsSelectors } from 'features/sessions';

const ManagerSessionsList = ({ manager_id }) => {
  const { getManagerSessions, clearLocalManagerSessions } = useSessions();
  const { data: sessions, pagination } = useCustomSelector(sessionsSelectors.getManagerSessions)
  const fetching = useCustomSelector(sessionsSelectors.isFetching)

  const fetchManagerSession = useCallback(( manager_id, offset ) => {
    getManagerSessions({ manager_id, offset });
  }, [getManagerSessions]);
  const handleScroll = ({ target: { scrollTop, scrollHeight, offsetHeight } }) =>
    (scrollTop + 65) >= scrollHeight - offsetHeight && pagination.total_count > pagination.count + pagination.offset && !fetching && fetchManagerSession(manager_id, pagination.limit + pagination.offset);
  
  useEffect(() => {
    fetchManagerSession(manager_id, 0);

    return clearLocalManagerSessions
  }, [manager_id, fetchManagerSession, clearLocalManagerSessions]);

  return (
    <StyledList onScroll={handleScroll}>
      {_map(sessions, (s) => <Item key={s.id} {...s} />)}
      {fetching && <ListSkeleton />}
      {sessions.length === 0 && !fetching &&  <Typography sx={{ textTransform: 'uppercase', textAlign: 'center' }}>no sessions</Typography>}
    </StyledList>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <ManagerSessionsList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);